import React from "react";
import { Icon } from "semantic-ui-react";
import "./index.css";

const directionStyles = {
  right: {
    className: "-next",
    iconName: "right",
  },
  left: {
    className: "-previous",
    iconName: "left",
  },
};

const ScrollButton = ({ onClick, direction }) => {
  const { className, iconName } = directionStyles[direction];
  return (
    <button onClick={onClick} className={`scroll-btn ${className}`}>
      <Icon name={`chevron ${iconName}`} />
    </button>
  );
};

export default ScrollButton;



// WEBPACK FOOTER //
// ./src/components/HorizontalSlider/components/ScrollButton/index.js